import { combineReducers } from 'redux';
import ssoSettingsReducer from './ssoSettingsReducer';
import ssoSetupFormReducer from './ssoSetupFormReducer/ssoSetupFormReducer';
export default combineReducers({
    setupForm: ssoSetupFormReducer,
    currentCompanySettings: ssoSettingsReducer,
});
